export default "__VITE_ASSET__BqSXEx3f__"